export default __webpack_public_path__ + "static/anuMehta1-a5ef928a68594f0d79f57fc076f0a05c.jpg";